<template>
  <div>
    <HomeNav />
    <section class="py-5 detail-block bg-grey200">
      <div class="container">
        <div class="row pb-4">
          <div class="col">
            <p>
              Searches related to : {{ searchKey }}
              <span v-if="nocontent">(no result found )</span>
            </p>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-if="nocontent == false">
        <div class="d-flex flex-wrap justify-content-center">
          <div
            class="col-desktop"
            v-for="(card, index) in currentCat"
            :key="index"
          >
            <div class="series-block withhover" @click="goToPlayer(card)">
              <img class="img-fluid" :src="card.thumbnail.large" alt="" />
              <div class="more-cnt text-center">
                <h5 class="pt-3">{{ card.name }}</h5>
                <p class="py-2">Duration {{card.metaData.running_time}}</p>
                <p>PG13</p>
                <p class="py-3">{{ card.description }}</p>
                <div class="d-flex justify-content-between">
                  <a  class="border circle-Sm" @click="voteVideo(card, true)">
                    <img class="like" src="../assets/img/like.svg" alt="" />
                  </a>

                  <a class="border circle-Sm"  @click="voteVideo(card, false)">
                    <img class="unlike" src="../assets/img/unlike.svg" alt="" />
                  </a>

                  <a class="border circle-Sm" @click="toggleFavorited(card)">
                    <img
                      src="../assets/img/minis-icon.svg"
                      v-if="my_favourite(card)"
                      alt=""
                      class="plus-icon"
                    />
                    <img class="plus-icon" src="../assets/img/plus.svg" v-else />
                  </a>
                </div>
                <div class="py-3 d-flex justify-content-center">
                  <a @click="playvideo(card)" class="d-inline-block">
                    <img src="../assets/img/play.svg" class="play" alt="" />
                  </a>
                </div>
                <div class="pt-2 d-flex justify-content-center">
                  <a
                    @click="goToDetail(card)"
                    class="d-inline-block btn btn-outline-light"
                  >
                    More
                    <i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";
import Helpers from "../Mixins/Helpers.js";
export default {
  name: "search",
  nocontent: false,
  components: {
    HomeNav,
  },
  mixins: [Helpers],
  created() {
		 this.$store.commit("showdefaultFooter", true);
  },
  computed: {
    searchKey() {
      return this.$store.state.search.message;
    },
    title() {
      return "Results for : " + this.currentKey;
    },
  },
  filters: {
    trimdis: function (value) {
      return value.slice(0, 80) + "...";
    },
  },
  mounted() {
    window.scroll(0, 0);
     this.$store.commit("showdefaultFooter", true);
  },
  data() {
    return {
      showloader: false,
      showVideo: false,
      currentVideo: {},
      currentCat: [],
      currentKey: "",
      show_right: false,
      nocontent: false,
      duidVal: null
    };
  },
  methods: {
    voteVideo(show, status) {
      this.$store
        .dispatch("voteVideo", {
          id: show.id,
          status: status,
        })
        .then(() => {});
    },
    goToPlayer(video) {
      if (this.isPlatformMobile() == true || this.isPlatformTablet() == true) {
        this.goToDetail(video);
      }
    },
    goToDetail(current) {
      var dynamicRoute = "";
      if (current.type == "vod") {
        dynamicRoute = "/details/" + current.id + "/search";
      } else if (current.type == "Season") {
        dynamicRoute = "/playlistdetails/" + current.id;
      }

      this.$router.push("" + dynamicRoute);
    },
    playvideo(current) {
      this.checkSubs(current);
    },

    checkSubs(current) {
      this.$store
        .dispatch("getVideoPlaybackURLV2", {
          videoId: current.id,
          deviceId: this.duidVal,
        })
        .then((res) => {
          if (current.type == "Series") {
            var currentCat = current.id;
            this.$store.dispatch("getCatalougeById", currentCat).then((res) => {
              var currentSeason = res._embedded.items[0].id;
              this.$store
                .dispatch("getCatalougeById", currentSeason)
                .then((res) => {
                  var currentSeasonVideoId = res._embedded.items[0].id;
                  var dynamicRoute = "/viewvideo/" + currentSeasonVideoId;
                  this.$router.push("" + dynamicRoute);
                });
            });
          } else {
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          }
        })
        .catch((err) => {
          if (err.response.data.error.status == "422") {
            // show upgrade screen popup
          }
          if (err.response.data.error.status == "403") {
            this.$store.commit("showPopup", true);
            window.scrollTo(0, 0);
          }
          if (err.response.data.error.status == "404 ") {
            this.$store.commit("showPopup", true);
           // this.$store.commit("setNotification", "Please try again later ");
            window.scrollTo(0, 0);
          }
          this.$store.commit("setLoader", false);
        });
    },
    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            // this.$store.commit("refreshMyList" ,true)
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
    getparentId() {
      return this.apiOptions;
    },
    getHrefToDetails(movie, parent) {
      return "/details/" + movie + "/" + this.apiOptions;
    },
    scrollLeft(amount) {
      this.scroll = setInterval(
        () => (this.$refs.scroller.scrollLeft += amount),
        5
      );
    },
    clearScroll() {
      clearInterval(this.scroll);
    },
    doSearch(key) {
      this.$store
        .dispatch("search", key)
        .then((res) => {
          if (res[1] == this.searchKey) {
            this.currentCat = res[0]._embedded.collections;
            this.$store.commit("updateSearchData", this.currentCat);
            this.nocontent = false;
            if (this.currentCat.length == 0) {
              this.nocontent = true;
            }
            //this.showloader=false;
          }
        })
        .catch((err) => {
          this.nocontent = true;
          //  this.showloader=false;
          this.$store.commit("setLoader", false);
        });
    },
  },
  created() {
    this.$store.commit("showPopup", false);
  },
  watch: {
    currentKey: function (val, oldval) {
      if (val == "") {
        this.currentCat = "";
        this.nocontent = false;
        this.showloader = false;
        return false;
      } else {
        this.showloader = true;
        this.currentCat = "";
        this.nocontent = false;
        this.doSearch(val);
      }
    },
    searchKey: function (val, oldval) {
      if (val == "") {
        this.currentCat = "";
        this.nocontent = false;
        this.showloader = false;
        return false;
      } else {
        this.showloader = true;
        this.currentCat = "";
        this.nocontent = false;
        this.doSearch(val);
      }
    },
  },
};
</script>
<style scoped>

.detail-block{
  min-height: 80vh;
}
</style>
